// extracted by mini-css-extract-plugin
export var optionGrid = "_61-7";
export var optionList = "_61-6";
export var questionsBlock = "_61-9";
export var spacer = "_61-5";
export var stepCenteredContent = "_61-3";
export var stepInner = "_61-0";
export var stepInnerFullWidth = "_61-1";
export var stepInnerLockScroll = "_61-2";
export var stepTransitionFrame = "_61-4";
export var welcomeBlock = "_61-8";